<template>
  <v-layout column>
    <v-flex xs12>
      <h1>Google Pixel</h1>
    </v-flex>
    <v-layout align-center wrap mt-4>
      <v-flex xs2 class="text-xs-right">
        <span class="title">Notification</span>
      </v-flex>
      <v-flex xs2 offset-xs1>
        <v-switch
          v-model="pixelNotificationEnabled"
          :label="notificationLabel"
          @change="updateNotification"
          hide-details
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { required, url } from 'vuelidate/lib/validators'
import { clone } from 'ramda'
import mixins from '@/utils/mixins'

export default {
  name: 'GooglePixel',
  components: {},
  props: {},
  data () {
    return {
      pixelNotificationEnabled: false
    }
  },
  computed: {
    ...mapGetters([
      'getGooglePixelSetting',
      'getSettings'
    ]),
    notificationLabel () {
      return this.pixelNotificationEnabled ? 'Enabled' : 'Disabled'
    }
  },
  methods: {
    ...mapActions([
      'putGooglePixelNotification',
      'fetchGeneralSettings'
    ]),
    updateNotification () {
      this.putGooglePixelNotification({'pixelNotificationEnabled': this.pixelNotificationEnabled})
    }
  },
  async created () {
    if (!this.getSettings) await this.fetchGeneralSettings()
    this.pixelNotificationEnabled = this.getGooglePixelSetting.pixelNotificationEnabled
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/GooglePixel/index.vue